import * as Rellax from 'rellax'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import * as SmoothScroll from 'smooth-scroll'

gsap.registerPlugin(ScrollTrigger);

export default function common() {
  if(document.getElementsByClassName('rellax').length > 0){
    const rellax = new Rellax('.rellax',{
      center:true
    });
  }

  if(document.getElementsByClassName('rellax-no').length > 0){
    const rellax_no = new Rellax('.rellax-no',{
      center:false
    })
  }

  const scroll = new SmoothScroll('a[href*="#"], [data-scroll]',{
    header: '#site-header',
    offset: 0,
    speed: 1000,
    easing: 'easeInOutQuart',
    speedAsDuration: true,
    durationMin: 1000
  })

  gsap.to('#fixFoot', {
    scrollTrigger: {
      trigger: '#site-app',
      start: 'top+=10% top',
      end: 'bottom top',
      toggleClass: {
        targets: '#fixFoot',
        className: 'active'
      },
      //markers: true
    }
  })

  gsap.utils.toArray(".scrollanimete").forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom-=20%",
      end: "bottom bottom",
      scrub: 1,
      once: true,
      invalidateOnRefresh: true,
      //markers: true,
      toggleClass: { targets: el, className: "active" },
    })
  })



}